// useCompanyFormModal.js
import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup"; // (추가)
import * as yup from "yup";                            // (추가)
import { get, post, put } from "@utils/axios_api";
import { toast } from 'react-toastify';

/* ==== 1) Yup Validation ==== */
const schema = yup.object().shape({
  siteName: yup
    .string()
    .required("사업장명을 입력하세요.")
    .max(20, "최대 20자까지 가능합니다."),
  bizNo: yup
    .string()
    .required("사업자등록번호를 입력하세요.")
    .max(10, "사업자등록번호는 10자리까지 입력 가능합니다.")
    .matches(/^[0-9]+$/, "숫자만 입력 가능합니다."),
  repName: yup
    .string()
    .required("대표자명을 입력하세요.")
    .max(20, "최대 20자까지 가능합니다."),
  phone: yup
    .string()
    .max(11, "전화번호는 최대 11자입니다.")
    .matches(/^[0-9]*$/, "숫자만 입력 가능합니다."),
  addr1: yup
    .string()
    .required("사업장 주소를 검색하세요."),
  addr2: yup
    .string()
    .max(50, "상세주소는 최대 50자까지 가능합니다."),
  notice: yup
    .string()
    .max(2000, "비고는 최대 2000자까지 가능합니다."),
});

export function useSiteFormModal({ isOpen, isEdit, boardNum, onClose, onSuccess, isAdmin }) {
  const methods = useForm({
    resolver: yupResolver(schema),   // Yup Validation 적용
    defaultValues: {
      siteCode: "",
      compCode: "",
      bizNo: "",
      siteName: "",
      repName: "",
      phone: "",
      addr1: "",
      addr2: "",
      notice: ""
    },
    shouldFocusError: false,
  });

  const { handleSubmit, setValue, watch, reset, formState } = methods;
  const [loadingDetail, setLoadingDetail] = useState(false);
  const [detailError, setDetailError] = useState(null);

  const basePath = isAdmin ? "/admin/site" : "/user/site";

  useEffect(() => {
    if (isOpen) {

      // 2) 편집 모드 => 상세 조회
      if (isEdit && boardNum) {
        setLoadingDetail(true);
        get(`${basePath}/${boardNum}`)
          .then((data) => {
            const result = data.result;
            reset({
              siteCode: result.siteCode || "",
              compCode: result.compCode || "",
              bizNo: result.bizNo || "",
              siteName: result.siteName || "",
              repName: result.repName || "",
              phone: result.phone || "",
              addr1: result.addr1 || "",
              addr2: result.addr2 || "",
              notice: result.notice || "",
            });
          })
          .catch((err) => {
            console.error("상세 데이터 조회 실패:", err);
            setDetailError(err);
          })
          .finally(() => {
            setLoadingDetail(false);
          });
      } else {
        // 등록 모드
        reset({
          siteCode: "",
          compCode: boardNum || "",
          bizNo: "",
          siteName: "",
          repName: "",
          phone: "",
          addr1: "",
          addr2: "",
          notice: ""
        });
      }
    }
  }, [isOpen, isEdit, boardNum, reset, basePath, setValue, watch]);

  // [2] 저장 처리
  const onSubmit = async (formData) => {
    // 저장 전 confirm
    if (!window.confirm("저장하시겠습니까?")) {
      return;
    }

    try {
      const siteCodeNum = Number(formData.siteCode);
      // 숫자 검증
    if (isEdit && Number.isNaN(siteCodeNum)) {
      toast.warn("유효하지 않은 siteCode 입니다.");
      return;
    }
      const url = isEdit
        ? `${basePath}/${siteCodeNum}`
        : `${basePath}/siteCreate`;

      const payload = isEdit
      ? { ...formData, siteCode: siteCodeNum } // 바디도 숫자로 맞춰줌
      : formData;

      const apiMethod = isEdit ? put : post;
      const response = await apiMethod(url, payload);

      if (response.status === false) {
        // 서버에서 status=false를 준 경우 (ex: bizNo 중복)
        toast.error(response.message || "오류가 발생했습니다.");
        return;
      }

      if (onSuccess) onSuccess(response);
      onClose();
    } catch (err) {
      console.error("저장 실패:", err);
    }
  };

  const handleFormSubmit = handleSubmit(onSubmit);

  return {
    ...methods,
    handleFormSubmit,
    loadingDetail,
    detailError,
    formState,
  };
}
